/* LWC - push sold-out products to the end of any product grid.

   Replaces the visible half of the OOS push-down app. The durable half is done
   in the collection data itself: sold-out products are moved to the end of every
   manually-sorted collection, so page 1 is in-stock. This script is the safety
   net for the collections on best-selling or alphabetical sort, for search
   results, and for the window between a product selling out and the next
   reorder run.

   It only reorders WITHIN the page the shopper is looking at. It cannot pull an
   in-stock product forward from page 3, and it deliberately does not try.

   The first version of this file re-triggered its own MutationObserver: moving a
   card is an added-node record, which scheduled another run, which moved cards
   again. The observer is now disconnected around every write and the work is
   idempotent, so a grid settles after one pass.
*/
(function () {
  'use strict';

  var SOLD_OUT = '.badge.soldout, .price--sold-out, .lwc-p__oos';
  var DONE = 'data-lwc-oos-sorted';
  var mo = null;
  var scheduled = null;

  function isSoldOut(card) {
    if (card.querySelector(SOLD_OUT)) return true;
    var txt = card.textContent || '';
    return /sold out|currently unavailable/i.test(txt) && !/in stock/i.test(txt);
  }

  function looksLikeProductGrid(grid) {
    var kids = grid.children;
    if (kids.length < 2) return false;
    var withProduct = 0;
    for (var i = 0; i < kids.length; i++) {
      if (kids[i].querySelector('a[href*="/products/"]')) withProduct++;
    }
    return withProduct >= 2 && withProduct >= kids.length - 1;
  }

  /* Returns true only when the DOM was actually changed. */
  function sortGrid(grid) {
    if (!looksLikeProductGrid(grid)) return false;
    var kids = Array.prototype.slice.call(grid.children);
    var out = [];
    for (var i = 0; i < kids.length; i++) {
      if (isSoldOut(kids[i])) out.push(kids[i]);
    }
    if (!out.length || out.length === kids.length) return false;

    /* Already settled: every sold-out card is in the trailing block. */
    var settled = true;
    for (var k = 0; k < out.length; k++) {
      if (kids[kids.length - out.length + k] !== out[k]) { settled = false; break; }
    }
    if (settled) return false;

    var frag = document.createDocumentFragment();
    for (var j = 0; j < out.length; j++) frag.appendChild(out[j]);
    grid.appendChild(frag);
    return true;
  }

  function run() {
    var grids = document.querySelectorAll(
      '[id^="shopify-section"] .grid, .product-grid .grid, .lwc-row'
    );
    if (!grids.length) return;

    /* Stop observing while we write, then resume. Without this the observer
       sees its own effects and reschedules itself forever. */
    if (mo) mo.disconnect();
    try {
      for (var i = 0; i < grids.length; i++) {
        var g = grids[i];
        if (g.getAttribute(DONE) === '1') continue;
        sortGrid(g);
        g.setAttribute(DONE, '1');
      }
    } finally {
      if (mo) observe();
    }
  }

  function schedule() {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(function () {
      scheduled = null;
      var marked = document.querySelectorAll('[' + DONE + ']');
      for (var i = 0; i < marked.length; i++) marked[i].removeAttribute(DONE);
      run();
    }, 80);
  }

  function observe() {
    var target = document.getElementById('MainContent') || document.body;
    if (!target || !mo) return;
    mo.observe(target, { childList: true, subtree: true });
  }

  function start() {
    run();
    if (!window.MutationObserver) return;
    mo = new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var added = records[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          /* Only care about whole grids or cards arriving, not text nodes or
             our own re-parenting of existing elements. */
          if (added[j].nodeType === 1 && !added[j].hasAttribute(DONE)) {
            schedule();
            return;
          }
        }
      }
    });
    observe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
